import axios from './request'
import formData from "~/utils/formData";

export const getActByName = (name) => axios
	.get(`/api/Acts/getActByName/?${new URLSearchParams({name}).toString()}`)
	.then(({data}) => data)

export const getRequestByName = (name) => axios
	.get(`/api/Requests/getInfoByName/?${new URLSearchParams({name}).toString()}`)
	.then(({data}) => data)

export const getRequestByPhone = (phone) => axios
	.get(`/api/Requests/getInfoByPhone/?${new URLSearchParams({phone}).toString()}`)
	.then(({data}) => data)

export const getRequestBySerial = (serial) => axios
	.get(`/api/Requests/getInfoBySerial/?${new URLSearchParams({serial}).toString()}`)
	.then(({data}) => data)

export async function updateStatuses(requests, status, config) {
	return axios.post('/api/Requests/updateStatuses/', formData({
			requests: requests,
			status: status,
		}),
		config).then(({data}) => data);
}
